export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20crimson%20and%20golden%20amber%20abstract%20digital%20art%20with%20flowing%20dynamic%20curves%20and%20soft%20glowing%20orbs%2C%20representing%20entertainment%20news%20and%20social%20media%20buzz%2C%20modern%20editorial%20magazine%20cover%20aesthetic%2C%20clean%20gradients%20with%20vivid%20warm%20accent%20highlights%2C%20atmospheric%20dramatic%20lighting%2C%20professional%20composition%20with%20organic%20texture%20layers&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="五一吃瓜网 - 热门吃瓜资讯聚合平台主视觉"
          className="w-full h-full object-cover object-top"
          onError={(e) => { (e.currentTarget as HTMLElement).style.display = 'none'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-300/40 text-accent-600 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              热门吃瓜聚集地
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              五一吃瓜网 - 最新最全吃瓜资讯聚合平台
            </h1>

            <p className="text-sm md:text-base text-background-200/90 mb-3 font-medium">
              全网热点一站直达，吃瓜不迷路
            </p>

            <p className="text-xs md:text-sm text-background-300/80 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              五一吃瓜网是专注热门事件追踪与娱乐八卦聚合的一站式资讯平台。覆盖娱乐圈热点、网红动态、综艺爆料、影视花边等多维度内容，每日实时更新最新吃瓜资讯，为瓜友提供官方认证的便捷入口。无论是最新明星八卦、热门综艺内幕还是社会热议事件，五一吃瓜网都能让你快速直接进入热门话题主页，不错过任何一个精彩瞬间。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2 text-background-100/80">
                <i className="ri-flashlight-line text-accent-400 text-lg"></i>
                <span className="text-xs md:text-sm font-medium">日更资讯 500+</span>
              </div>
              <div className="flex items-center gap-2 text-background-100/80">
                <i className="ri-stack-line text-accent-400 text-lg"></i>
                <span className="text-xs md:text-sm font-medium">覆盖 15+ 频道</span>
              </div>
              <div className="flex items-center gap-2 text-background-100/80">
                <i className="ri-user-heart-line text-accent-400 text-lg"></i>
                <span className="text-xs md:text-sm font-medium">千万瓜友聚集</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-5 py-2.5 md:px-6 md:py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm md:text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-emotion-happy-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 px-5 py-2.5 md:px-6 md:py-3 bg-background-50/20 hover:bg-background-50/30 border border-background-50/30 text-background-50 rounded-full text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border border-background-50/15">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20editorial%20collage%20style%20illustration%20with%20warm%20crimson%20and%20golden%20tones%2C%20overlapping%20magazine%20cutout%20shapes%20representing%20entertainment%20news%20headlines%20and%20social%20media%20trending%20topics%2C%20dynamic%20geometric%20elements%20with%20soft%20glowing%20highlights%2C%20modern%20minimalist%20design%20aesthetic%20with%20paper%20texture%20overlay%2C%20professional%20visual%20composition%20with%20warm%20ambient%20atmosphere&width=800&height=600&seq=hero-visual&orientation=landscape"
                alt="五一吃瓜网主视觉 - 热门娱乐资讯聚合展示"
                className="w-full h-full object-cover"
                onError={(e) => { (e.currentTarget as HTMLElement).style.display = 'none'; }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}